import http from '@libs/services/http'
import {
  HousingMarketSearchQuery,
  ComparableMarketResponse
} from '@libs/types/generated/housing-market-ui'

const apiUrl = process.env.NEXT_PUBLIC_HOUSING_MARKET_API_URL

export async function fetchHousingMarket(
  query: Partial<HousingMarketSearchQuery>
) {
  const url = `${apiUrl}/housing-market`
  const { data } = await http.get(url, { params: query })
  return data
}

export async function fetchComparableMarkets(
  query: Partial<HousingMarketSearchQuery>
): Promise<ComparableMarketResponse[]> {
  const url = `${apiUrl}/housing-market/comparable-markets`
  const { data } = await http.get(url, { params: query })
  return data
}
